<div class="wrapper" *ngIf="menuItem">

  <div>
    <div>{{menuItem.label}}</div>
    <div class="small">{{menuItem.route}}</div>
  </div>

  <div class="overlay" *ngIf="mouseActive">
    <div class="d-flex">
      <fa-icon [icon]="faArrowLeft" (click)="onMenuMoved(-1)"></fa-icon>
      <fa-icon [icon]="faArrowUp" (click)="onMove(-1)"></fa-icon>
      <fa-icon [icon]="faArrowDown" (click)="onMove(+1)"></fa-icon>
      <fa-icon [icon]="faArrowRight" (click)="onMenuMoved(+1)"></fa-icon>
    </div>
    <div class="d-flex justify-content-center">
      <fa-icon [icon]="faPlus" (click)="onAdd()"></fa-icon>
      <fa-icon [icon]="faEdit" (click)="onEditMenuItem(content)"></fa-icon>
      <fa-icon [icon]="faTrash" (click)="onDelete()"></fa-icon>
    </div>
  </div>
</div>

<ng-template #content>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Menu Item</h4>
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="menuItemForm" (ngSubmit)="onSave()">
      <div class="form-group">
        <label for="label">Label</label>
        <input id="label" class="form-control" [formControlName]="'label'">
      </div>
      <div class="form-group">
        <label for="route">Route</label>
        <input id="route" class="form-control" [formControlName]="'route'">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
  </div>
</ng-template>
